import api from './api';

/**
 * Get a presigned URL for uploading a sponsor logo
 * @param {string} filename - Original filename with extension
 * @returns {Promise<{key: string, uploadUrl: string, viewUrl: string}>}
 */
export const getPresignedLogoUploadUrl = async (filename) => {
  const response = await api.get(`/s3/presign-logo?filename=${encodeURIComponent(filename)}`);
  return response.data;
};

/**
 * Upload a file to S3 using a presigned URL
 * @param {string} uploadUrl - The presigned upload URL
 * @param {File} file - The file to upload
 * @returns {Promise<void>}
 */
export const uploadFileToS3 = async (uploadUrl, file) => {
  await fetch(uploadUrl, {
    method: 'PUT',

    headers: {
      'Content-Type': file.type,
    },
  });
}; 